import phone from 'phone';
import { z } from 'zod';

export const baseParentSchema = z.object({
  id: z.string().uuid(),
  relation: z.string().min(1, 'Relation is required'),
  first_name: z.string().min(1, 'First name is required').max(50, 'Please enter a valid first name').default(''),
  last_name: z.string().min(1, 'Last name is required').max(50, 'Please enter a valid last name').default(''),
  email: z.string({ required_error: 'Email is required' }).email('Please enter a valid email address'),
  email_verification_request: z
    .object({
      contact_type: z.literal('email'),
      contact_value: z.string(),
      expires_at: z.string(),
      status: z.enum(['pending', 'verified']),
      sent_at: z.string().nullable(),
      verified_at: z.string().nullable(),
    })
    .nullish()
    .transform(() => undefined),
  cell_phone: z.string().refine((value) => !value || phone(value).isValid, {
    message: 'Phone number is invalid',
  }),
  home_phone: z.string().refine((value) => !value || phone(value).isValid, {
    message: 'Phone number is invalid',
  }),
  work_phone: z.string().refine((value) => !value || phone(value).isValid, {
    message: 'Phone number is invalid',
  }),
  work_extension: z.string(),
});

export const parentSchema = baseParentSchema
  .refine((value) => {
    if (!value.work_phone) {
      // remove work_extension when work_phone is falsy
      value.work_extension = '';
    }
    return true;
  })
  .refine((value) => !!value.cell_phone || !!value.home_phone || !!value.work_phone, {
    message: 'At least one phone number is required for each parent',
    path: ['root'],
  });

export type ParentInputValues = z.input<typeof baseParentSchema>;
export type ParentOutputValues = z.output<typeof baseParentSchema>;

export default parentSchema;
